import React from 'react';
import PropTypes from 'prop-types';

const BroadcastReportList = (props) => {
  const { data = [], emptyMessage = 'No data available' } = props;
  const typeMapping = {
    New: { title: 'New', color: '#2cabe3' },
    Ringing: { title: 'Ringing', color: '#6376ff' },
    Answer: { title: 'Answer', color: '#008000' }
  };

  return (
    <div
      className={`report-list-table-wrapper${data.length === 0 ? ' is-empty' : ''}`}
      style={{ maxHeight: 'calc(100vh - 252px)', minHeight: 'calc(100vh - 252px)' }}>
      <table className="report-list-table">
        <thead>
          <tr>
            <th>Process Name</th>
            <th>Type</th>
            <th>Forwarding Type</th>
            <th>Forwarding Options</th>
            <th>Phone No</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => {
            const userType = row.type;
            const bgColor = typeMapping[userType]?.color || '#ffffff';

            return (
              <tr key={index} style={{ backgroundColor: `${bgColor}33` }}>
                <td>{row.process_name || '-'}</td>
                <td>{row.type}</td>
                <td>{row.forwarding_type}</td>
                <td>{row.forwarding_options}</td>
                <td>{row.phone_number || '-'}</td>
                <td>{row.time_difference}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {data.length === 0 && <div className="report-list-empty">{emptyMessage}</div>}
    </div>
  );
};

BroadcastReportList.propTypes = {
  data: PropTypes.array.isRequired,
  emptyMessage: PropTypes.string
};

export default BroadcastReportList;
